import React, { FunctionComponent } from 'react';
import { Post } from '../../../types/posts';
import classnames from 'classnames';
import { LuminousGalleryWrapper } from '../../../utils/luminousGallery';

type Props = {
  post: Post;
  companyId: number;
};

export const Presentation: FunctionComponent<Props> = ({
  post,
  companyId,
}) => {
  return (
    <li className="articles-list-story">
      <div className="articles-list-story-author">

        <a
        
          href={`/companies/${companyId}/story_show?post_id=${post.id}`}
          className="articles-list-story-author-link"
        >
          {post.title && <p className="articles-list-story-author-title">{post.title}</p>}

          <div
            className="articles-list-story-body"
            dangerouslySetInnerHTML={{ __html: post.body }}
          />
        </a>

        <LuminousGalleryWrapper>
          {post.images.length > 0 && (
            <div className="articles-list-story-images">
              {post.images.map((img, i) => (
                <a
                  key={i}
                  href={img.url}
                  className={classnames(
                    "luminous",
                    img.isWide
                      ? "articles-list-story-images-wide"
                      : "articles-list-story-images-narrow"
                  )}
                >
                  <img src={img.url} alt={img.alt} />
                </a>
              ))}
            </div>
          )}
        </LuminousGalleryWrapper>

        <time dateTime={post.updatedAt} className="articles-list-story-time">
          更新 {post.formattedUpdatedAt}
        </time>
      </div>
    </li>
  );
};
